var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmarttv = function SvgSmarttv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3C1.725 3 0.75 3.975 0.75 5.25V17.25C0.75 18.525 1.725 19.5 3 19.5H7.5V22.5H16.5V19.5H21C22.275 19.5 23.25 18.525 23.25 17.25V5.25C23.25 3.975 22.275 3 21 3ZM11.25 9H9V15H7.5V9H5.25V7.5H11.25V9ZM16.275 15H14.475L12 7.5H13.575L15.375 12.975L17.175 7.5H18.75L16.275 15Z",
    fill: "#71BBFF"
  })));
};
export default SvgSmarttv;